import { BarChart, LineChart } from "@mui/x-charts";
import { Box, Grid, Paper, Typography } from "@mui/material";
import { format, parseISO } from "date-fns";

export const MonthlyFlightsChart = ({ statistics, selectedSystem }) => {
    const systemStatistics =
        selectedSystem === "All"
            ? statistics
            : statistics.filter(
                  (statistic) => statistic.system === selectedSystem
              );
    const allMonthsSet = new Set(
        systemStatistics
            .flatMap((statistic) => [
                ...statistic.plannedMonthlyMissions,
                ...statistic.receivedMonthlyMissions,
            ])
            .map((mission) => mission.date)
    );
    const sortedMonths = Array.from(allMonthsSet).sort();

    const computeMonthlyFlightCounts = (key) => {
        return sortedMonths.map((month) =>
            systemStatistics.reduce((sum, statistic) => {
                const mission = statistic[key]?.find(
                    (mission) => mission.date === month
                );
                return sum + (mission?.count || 0);
            }, 0)
        );
    };
    const plannedMonthlyFlightCount = computeMonthlyFlightCounts(
        "plannedMonthlyMissions"
    );
    const receivedMonthlyFlightCount = computeMonthlyFlightCounts(
        "receivedMonthlyMissions"
    );

    const calculateCumulativeCounts = (counts) => {
        let sum = 0;
        return counts.map((count) => (sum += count));
    };
    const cumulativePlannedCounts = calculateCumulativeCounts(
        plannedMonthlyFlightCount
    );
    const cumulativeReceivedCounts = calculateCumulativeCounts(
        receivedMonthlyFlightCount
    );

    const formattedMonths = sortedMonths.map((month) =>
        format(parseISO(month), "MMM yy")
    );
    const chartWidth = Math.max(formattedMonths.length * 60, 500);

    return (
        <Grid container spacing={2}>
            <Grid
                size={{
                    lg: 8,
                    xl: 6,
                }}
            >
                <Paper elevation={2}>
                    <Typography variant="h6" sx={{ textAlign: "center" }}>
                        Monthly Flights
                    </Typography>
                    <Box sx={{ overflowX: "auto" }}>
                        <BarChart
                            xAxis={[
                                {
                                    scaleType: "band",
                                    data: formattedMonths,
                                    tickLabelStyle: { fontSize: 11 },
                                },
                            ]}
                            series={[
                                {
                                    data: plannedMonthlyFlightCount,
                                    label: "Planned",
                                },
                                {
                                    data: receivedMonthlyFlightCount,
                                    label: "Received",
                                },
                            ]}
                            slotProps={{
                                legend: {
                                    itemMarkHeight: 13,
                                    itemMarkWidth: 13,
                                },
                            }}
                            width={chartWidth}
                            height={300}
                        />
                    </Box>
                </Paper>
            </Grid>
            <Grid
                size={{
                    lg: 8,
                    xl: 6,
                }}
            >
                <Paper elevation={2}>
                    <Typography variant="h6" sx={{ textAlign: "center" }}>
                        Monthly Cumulative Flights
                    </Typography>
                    <Box sx={{ overflowX: "auto" }}>
                        <LineChart
                            xAxis={[
                                {
                                    scaleType: "point",
                                    data: formattedMonths,
                                    tickLabelStyle: { fontSize: 11 },
                                },
                            ]}
                            series={[
                                {
                                    data: cumulativePlannedCounts,
                                    label: "Planned",
                                },
                                {
                                    data: cumulativeReceivedCounts,
                                    label: "Received",
                                },
                            ]}
                            slotProps={{
                                legend: {
                                    itemMarkHeight: 13,
                                    itemMarkWidth: 13,
                                },
                            }}
                            width={chartWidth}
                            height={300}
                        />
                    </Box>
                </Paper>
            </Grid>
        </Grid>
    );
};
